import { rootApi } from "../../api/rootApi";

export const zoneStateMasterApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchZoneMasterList: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/zone-master/list`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    addZoneMaster: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/zone-master/add`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    updateZoneMaster: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/zone-master/update`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    deleteZoneMaster: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/zone-master/delete`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    uploadZoneMasterCsv: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/zone-master/upload-csv`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    fetchStateMasterList: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/state-master/list`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    addStateMaster: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/state-master/add`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    updateStateMaster: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/state-master/update`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    deleteStateMaster: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/state-master/delete`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    uploadStateMasterCsv: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/state-master/upload-csv`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    fetchDistrictMasterStates: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/district-master/states`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    fetchDistrictMasterList: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/district-master/list`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    addDistrictMaster: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/district-master/add`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    updateDistrictMaster: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/district-master/update`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    deleteDistrictMaster: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/district-master/delete`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    uploadDistrictMasterCsv: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/district-master/upload-csv`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const {
  useFetchZoneMasterListMutation,
  useAddZoneMasterMutation,
  useUpdateZoneMasterMutation,
  useDeleteZoneMasterMutation,
  useUploadZoneMasterCsvMutation,
  useFetchStateMasterListMutation,
  useAddStateMasterMutation,
  useUpdateStateMasterMutation,
  useDeleteStateMasterMutation,
  useUploadStateMasterCsvMutation,
  useFetchDistrictMasterStatesMutation,
  useFetchDistrictMasterListMutation,
  useAddDistrictMasterMutation,
  useUpdateDistrictMasterMutation,
  useDeleteDistrictMasterMutation,
  useUploadDistrictMasterCsvMutation,
} = zoneStateMasterApi;
